import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { ErrorStateMatcher, MAT_DATE_LOCALE, ShowOnDirtyErrorStateMatcher } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MAT_RADIO_DEFAULT_OPTIONS, MatRadioModule } from '@angular/material/radio';
import { MatTabsModule } from '@angular/material/tabs';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { CookieService } from 'ngx-cookie-service';
import { ToastrModule } from 'ngx-toastr';
import { LayoutModule } from './_layout/layout.module';
import { MainXsrfInterceptorService } from './_shared/interceptors/main-xsrf-interceptor.service';
import { AdminModule } from './admin/admin.module';
import { DashboardModule } from './admin/dashboard/dashboard.module';
import { UserModule as AdminUserModule } from './admin/user/user.module';
import { LeadModule } from './admin/lead/lead.module';
import { PackagerModule } from './packager/packager.module';
import { AffiliateUserModule } from './affiliate-user/affiliate-user.module';

import { StatsComponent } from './admin/stats/stats.component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { ClientModule } from './client/client.module';
import { DashboardWrapperComponent } from './dashboard-wrapper/dashboard-wrapper.component';
import { DistributionModule } from './distribution/distribution.module';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PublicModule } from './public/public.module';
import { UserModule } from './user/user.module';
import localeSpanish from '@angular/common/locales/es';

registerLocaleData(localeSpanish);

@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    DashboardWrapperComponent,
    StatsComponent,
  ],
  imports:      [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatDialogModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatMenuModule,
    MatRadioModule,
    MatTabsModule,
    DashboardModule,
    AdminModule,
    AuthModule,
    DistributionModule,
    ClientModule,
    LeadModule,
    PackagerModule,
    UserModule,
    AdminUserModule,
    AffiliateUserModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json',
      }),
    }),
    LayoutModule,
    PublicModule,
    AppRoutingModule,
  ],
  providers:    [
    CookieService,
    {provide: HTTP_INTERCEPTORS, useClass: MainXsrfInterceptorService, multi: true},
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'outline'}},
    {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {floatLabel: 'auto'}},
    {provide: MAT_RADIO_DEFAULT_OPTIONS, useValue: {color: 'primary'}},
    {provide: ErrorStateMatcher, useClass: ShowOnDirtyErrorStateMatcher},
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    {provide: LOCALE_ID, useValue: 'es'},
    {provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR'}
  ],
  bootstrap:    [AppComponent],
})
export class AppModule {
}
